import React from 'react'

export interface IProps {
    width?: number
    height?: number
}

const FacebookIcon = ({ width = 24, height = 24 }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M21 18.5C21 19.881 19.881 21 18.5 21H5.5C4.1195 21 3 19.881 3 18.5V5.5C3 4.119 4.1195 3 5.5 3H18.5C19.881 3 21 4.119 21 5.5V18.5Z'
                fill='#1877F2'
            />
            <path
                d='M17.184 12.5H15.5V19H13V12.5H11.5V10.5H13V9.295C13.001 7.541 13.7295 6.5 15.796 6.5H17.5V8.5H16.3565C15.552 8.5 15.5 8.8 15.5 9.3615V10.5H17.5L17.184 12.5Z'
                fill='white'
            />
        </svg>
    )
}

export default React.memo(FacebookIcon)
